import { render, staticRenderFns } from "./BindWeChat.vue?vue&type=template&id=65effe6f&scoped=true&"
import script from "./BindWeChat.vue?vue&type=script&lang=js&"
export * from "./BindWeChat.vue?vue&type=script&lang=js&"
import style0 from "./BindWeChat.vue?vue&type=style&index=0&id=65effe6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65effe6f",
  null
  
)

export default component.exports